import styled from 'styled-components';

export const StyledPre = styled.pre`
  padding: 12px 0 12px 12px;
  margin-bottom: 0;
  border-radius: 4px;

  &::-webkit-scrollbar {
    display: none;
  }
`;
